export default __webpack_public_path__ + "static/media/(17).fb8db5a6.JPG";